"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
/**
 * Primary UI component for user interaction
 */
var Button = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, outline = _a.outline, type = _a.type, title = _a.title, responsive = _a.responsive;
    return react_1.default.createElement("button", { className: storybook_1.Helpers.classNames('storybook-buttons-button', "storybook-buttons-button-" + type, icon ? 'storybook-buttons-button-icon' : '', outline ? 'outline' : '', children && icon ? 'storybook-buttons-button-group' : '', className), onClick: onClick ? function () { return onClick(); } : null, disabled: disabled, title: title }, icon ? react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Icons.Icon, { name: icon, className: 'w-5' }),
        children && react_1.default.createElement("span", { className: "" + (responsive ? 'hidden sm:inline' : '') }, children)) : children);
};
exports.Button = Button;
exports.Button.propTypes = {
    /**
     * Use a different classname
     */
    className: prop_types_1.default.string,
    /**
     * The title of the Buttons
     */
    children: prop_types_1.default.any,
    /**
     * the color of a Submit button
     */
    type: prop_types_1.default.oneOf(['light', 'default', 'primary', 'secondary']),
    /**
     * Whether or not button is an outline only button
     */
    outline: prop_types_1.default.bool,
    /**
     * The onClick function of the Buttons
     */
    onClick: prop_types_1.default.func,
    /**
     * Button acts responsive for mobile
     */
    responsive: prop_types_1.default.bool
};
exports.Button.defaultProps = {
    className: '',
    disabled: false,
    type: 'default',
    outline: false,
    responsive: true
};
